import React, {useState, Fragment, useEffect, useRef} from "react";
import {MapContainer, TileLayer} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import L from "leaflet";
import "leaflet-draw";

export default function PolygonMap() {
  useEffect(() => {
    const map = L.map("map").setView([33.8938, 35.5018], 12); // Beirut

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(map);

    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);

    const drawControl = new L.Control.Draw({
      draw: {polygon: true, polyline: false, rectangle: false, circle: false, marker: false},
      edit: {featureGroup: drawnItems},
    });
    map.addControl(drawControl);

    map.on(L.Draw.Event.CREATED, async (e) => {
      const layer = e.layer;
      drawnItems.addLayer(layer);

      const coords = layer.getLatLngs()[0].map((p) => [p.lng, p.lat]);

      // Send to backend
      await fetch("/api/polygon", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({name: "My Polygon", coordinates: coords}),
      });
    });
  }, []);

  return <div id="map" style={{height: "500px"}} />;
}
